import { AdvancedModeModule } from './../../advanced-mode/advanced-mode.module';
import { DirectorySearchSelectionComponent } from './directory-search-selection.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
  declarations: [DirectorySearchSelectionComponent],
  exports: [DirectorySearchSelectionComponent],
  imports: [
    CommonModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    ReactiveFormsModule,
    ButtonModule,
    ButtonsModule,
    DropDownsModule,
    AdvancedModeModule
  ]
})
export class DirectorySearchSelectionModule { }
